// Section copy: Editable via SiteSettings API. See CMS-CONTENT-PLAN.md item #9.
import { useEffect, useState } from "react";
import { Box, Container, Heading, Image, Stack, Text } from "@chakra-ui/react";
import { useCmsApi } from "../../services/useCmsApi";

const DEFAULT_FIELD_COVERAGE_HEADING = "Where Growers Are Using Geco";

export const FieldCoverageSection = (): JSX.Element => {
	const cmsApi = useCmsApi();
	const [globalIsInset, setGlobalIsInset] = useState(true);
	const [heading, setHeading] = useState(DEFAULT_FIELD_COVERAGE_HEADING);

	useEffect(() => {
		cmsApi.getSiteSetting("fieldCoverageHeading").then((s) => { if (s?.value) setHeading(s.value); }).catch(() => {});
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<Box py={{ base: "16", md: "24" }} bg="white">
			<Container maxW="1560px">
				<Stack spacing="8" align="center">
					<Stack spacing="3" textAlign="center" align="center">
						<Heading size={{ base: "sm", md: "xl" }} color="gray.800">
							{heading}
						</Heading>
						<Text color="gray.600" fontSize={{ base: "lg", md: "xl" }} maxW="2xl" mx="auto">
							Farmers across the Canadian Prairies and beyond are using Geco maps to focus attention where it matters most in each field.
						</Text>
					</Stack>
					<Box position="relative" maxW="1040px" w="full">
						{/* Both main images rendered always — only one visible at a time */}
						<Image
							loading="lazy"
							src="/North%20America%20website%20map.PNG"
							alt="Map of Geco fields across North America"
							w="full"
							borderRadius="lg"
							border="1px solid"
							borderColor="gray.200"
							display={globalIsInset ? "block" : "none"}
						/>
						<Image
							loading="lazy"
							src="/Global%20website%20map.PNG"
							alt="Global map of Geco fields"
							w="full"
							borderRadius="lg"
							border="1px solid"
							borderColor="gray.200"
							display={globalIsInset ? "none" : "block"}
						/>

						{/* Inset — click to swap */}
						<Box
							position="absolute"
							top="4"
							right="4"
							w={{ base: "32%", md: "30%", lg: "28%" }}
							borderRadius="lg"
							border="2.5px solid black"
							overflow="hidden"
							boxShadow="0 4px 20px rgba(0,0,0,0.45)"
							cursor="pointer"
							onClick={() => setGlobalIsInset((v) => !v)}
							title="Click to swap maps"
							transition="transform 0.15s ease, box-shadow 0.15s ease"
							_hover={{ transform: "scale(1.03)", boxShadow: "0 6px 24px rgba(0,0,0,0.55)" }}
						>
							<Image
								loading="lazy"
								src="/Global%20website%20map.PNG"
								alt="Global map of Geco fields"
								w="full"
								display={globalIsInset ? "block" : "none"}
							/>
							<Image
								loading="lazy"
								src="/North%20America%20website%20map.PNG"
								alt="Map of Geco fields across North America"
								w="full"
								display={globalIsInset ? "none" : "block"}
							/>
						</Box>
					</Box>
				</Stack>
			</Container>
		</Box>
	);
};
